import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Vuetify from "vuetify";
import VuetifyConfirm from 'vuetify-confirm';
import "vuetify/dist/vuetify.min.css";
import "../assets/css/common.scss";
import {AuthenticationService} from "./services/authentication.service";
import {SECURITY_FETCH_USER, SECURITY_STORE_TARGET_URL} from "./store/actions.type";

// Modal confirm
Vue.use(VuetifyConfirm, {
    buttonTrueText: 'Oui',
    buttonFalseText: 'Non',
    color: 'red lighten-1',
    icon: 'warning',
    title: 'Attention',
});
Vue.use(Vuetify);
Vue.config.productionTip = false;

// Vérification de l'authentification
router.beforeEach((to, from, next) => {
    if (AuthenticationService.getToken() || to.name === 'login') {
        if (store.getters.currentUser === null && to.name !== 'login') {
            store.dispatch(SECURITY_FETCH_USER);
        }

        next();
    } else {
        store.dispatch(SECURITY_STORE_TARGET_URL, to.fullPath);
        next('/login');
    }
});

// Instance Vue
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
